import { useCallback } from 'react';

import useGoogleTagManager from '@hooks/useGoogleTagManager';
import {
  assembleFeedbackDismissGTMEvent,
  assembleFeedbackSubmitGTMEvent,
} from '@utils/GoogleTagManager';

const useTrackGTMEvents = () => {
  const { setGTMEvent } = useGoogleTagManager();

  const trackFeedbackDismiss = useCallback(
    () => setGTMEvent(assembleFeedbackDismissGTMEvent()),
    [setGTMEvent],
  );

  const trackFeedbackSubmit = useCallback(
    () => setGTMEvent(assembleFeedbackSubmitGTMEvent()),
    [setGTMEvent],
  );

  return { trackFeedbackDismiss, trackFeedbackSubmit };
};

export default useTrackGTMEvents;
